import './bootstrap';

$(function() {
    /*
    function formatCountry (country) {
        if (!country.id) { return country.text; }
        var $country = $(
            '<span class="flag-icon flag-icon-'+ country.iso.toLowerCase() +' flag-icon-squared"></span>' +
            '<span class="flag-text">'+ country.text+"</span>"
        );
        return $country;
    };

    //Assuming you have a select element with name country
    // e.g. <select name="name"></select>
    if(typeof isoCountries!='undefined') {
        $("[name='country']").select2({
            placeholder: "Select a country",
            templateResult: formatCountry,
            data: isoCountries

        });
    }
    */
    $('#copyLeftNELink').on('click', function(e) {
        e.preventDefault();
        const options = {
            html: true,
            placement: 'top',
            trigger: 'manual',
            delay: {"show": 0, "hide": 100}
            //content: '<div class="text-center"><i class="fas fa-check-circle fa-2x"></i></div>',
            //delay: { "show": 100, "hide": 100 },
            //template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
        }
        const _url = $(this).attr('href').replace('#','');
        navigator.clipboard.writeText(_url);
        const elem = $(this).get(0);
        const tooltip = new bootstrap.Tooltip(elem, options);
        tooltip.toggle();
        setTimeout(function(){
            tooltip.hide();
        }, 500);
        return false;
    });

    $('#copyRightNELink').on('click', function(e) {
        e.preventDefault();
        const options = {
            placement: 'bottom',
            trigger: 'manual',
            delay: {"show": 0, "hide": 100}
        }
        const _url = $(this).attr('href').replace('#','');
        navigator.clipboard.writeText(_url);
        const elem = $(this).get(0);
        const tooltip = new bootstrap.Tooltip(elem, options);
        tooltip.toggle();
        setTimeout(function(){
            tooltip.hide();
        }, 500);
        return false;
    });

    $('#copyLink').on('click', function(e) {
        e.preventDefault();
        const options = {
            placement: 'bottom',
            trigger: 'manual',
            delay: {"show": 0, "hide": 100}
        }
        const _url = $(this).attr('href').replace('#','');
        navigator.clipboard.writeText(_url);
        const elem = $(this).get(0);
        const tooltip = new bootstrap.Tooltip(elem, options);
        tooltip.toggle();
        setTimeout(function(){
            tooltip.hide();
        }, 500);
        return false;
    });

    //$('#walletTransferForm')

    $('.password-show i').on('click', function () {
        $(this).toggleClass('fa-eye').toggleClass('fa-eye-slash');
        $(this).parent().find('input').each(function (inx, ele) {
            $(ele).attr('type', $(ele).attr('type') === 'password' ? 'text' : 'password');
        });
    });
    //===========================================================================
    var $sliderIsInitialized = false;
    var $cropper = null;
    var $modal = document.getElementById('profileImageModal');
    if($modal !== null) {
        var $modalObj = new bootstrap.Modal($modal, {backdrop: false});
        $modal.addEventListener('show.bs.modal', function(e) {
            $cropper = new Cropper($newProfileImage, {
                aspectRatio: 1,
                viewMode: 3,
                autoCropArea: 0.5,
                dragMode: 'move',
                preview: '.profile_image_preview',
                ready: function() {
                    $cropper.zoomTo(0);
                    let imageData = $cropper.getImageData();
                    var minSliderZoom = imageData.width / imageData.naturalWidth;
                    $("#zoom-slider").prop('min', minSliderZoom);
                    $("#zoom-slider").prop('value', minSliderZoom);
                }
            });
        });
        $modal.addEventListener('hidden.bs.modal', function(e) {
            if($cropper) {
                $cropper.destroy();
                $cropper = null;
                $sliderIsInitialized = false;
            }
        });
    }
    var $newProfileImage = document.getElementById('newProfileImage');
    var doneLoading = function(url) {
        $newProfileImage.src = url;
        $sliderIsInitialized = true;
        $modalObj.show();
    };
    $("#zoom-slider").on('input', function (event) {
        if ($sliderIsInitialized == true) {
            //if ($cropper.canvasData.naturalWidth < 400 || $cropper.canvasData.naturalHeight < 300) {
            //    event.preventDefault();
            //} else {
                //var currentValue = event.target.value; //$("#zoom-slider").val();
                var currentValue = $("#zoom-slider").val();
                var zoomValue = parseFloat(currentValue);
                $cropper.zoomTo(zoomValue.toFixed(4));
            //}
        }
    });
    $('#changeProfile').on('click', function() {
        $('#file_profile_image')
            .on('change', function(e) {
                let file = e.target.files;
                if(file && file.length > 0) {
                    file = file[0];
                    if(URL) {
                        doneLoading(URL.createObjectURL(file));
                    } else if(FileReader) {
                        let reader = FileReader();
                        reader.onload = function(e) {
                            doneLoading(reader.result);
                        }
                        reader.readAsDataURL(file);
                    }
                }
            })
            .trigger('click');
    });
    $('#btnUpdateProfileImage').on('click', function() {
        let canvas = $cropper.getCroppedCanvas({
            width: 200,
            height: 200,
        });
        $('#loading').removeClass('d-none').css('display', 'flex');
        canvas.toBlob(function(blob) {
            let _formData = new FormData();
            _formData.append('avatar', blob, 'avatar.png');
            _formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
            let _url = URL.createObjectURL(blob);
            //let reader = new FileReader();
            //reader.readAsDataURL(blob);
            //reader.onloadend = function() {
                //var base64data = reader.result;
                $.ajax({
                    url: $baseUrl + "/newera/profile/upload-picture",
                    type: "POST",
                    data: _formData,
                    processData: false,
                    contentType: false,
                    //enctype: 'multipart/form-data',
                    //headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')},
                    success: function(data) {
                        //console.log(data);
                        if(data.status != undefined && data.status === 'ok') {
                            top.location.reload();
                            //document.querySelector('.profile_image').src = _url;
                        }
                    }
                }).done(function() {
                    //
                }).fail(function() {
                    $('#loading').addClass('d-none').css('display', 'none');
                    alert("Unable to upload profile image, please try again.");
                    $modalObj.hide();
                });
            //}
        }, 'image/png');
    });
    //===========================================================================
    $(".form-control").on('input', function () {
        $(this).parent().addClass("focus");
    });
});
